// Payment info block for list rows

import './PaymentInfo.scss';

export default function PaymentInfo({
  paid,
  discount,
  remaining,
  deposit,
  disabled,
  children,
}) {
  const status =
    remaining <= 0 ? 'paid' : paid >= (deposit ?? 0) ? 'partial' : 'unpaid';

  return (
    <div className={'payment-info ' + status + (disabled ? ' disabled' : '')}>
      <p>
        Paid:<span className='font-medium'>{' $' + (paid || 0)}</span>
      </p>
      {discount > 0 && (
        <p>
          Discount:<span className='font-medium'>{' $' + discount}</span>
        </p>
      )}
      <p>
        Remaining:
        <span className='font-medium'>
          {' $' + (remaining < 0 ? 0 : remaining)}
        </span>
      </p>
      {children}
    </div>
  );
}
